const AMOUNT = 'Amount'
const PERCENTAGE = 'Percentage'
const GIFT = 'Gift'
const FOC = 'FOC'
module.exports = { AMOUNT, PERCENTAGE, GIFT, FOC }
